import React from "react";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="px-6 lg:px-10 py-8 border-b border-navy-900/10 bg-white flex flex-col md:flex-row md:items-center justify-between gap-4">
      <div>
        <div className="label-eyebrow">Admin</div>
        <h1 className="serif text-3xl md:text-4xl mt-1">{title}</h1>
        {subtitle && <p className="text-navy-900/60 text-sm mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function AdminBody({ children }) {
  return <div className="p-6 lg:p-10">{children}</div>;
}

export function Card({ children, className = "" }) {
  return <div className={`bg-white border border-navy-900/10 ${className}`}>{children}</div>;
}

export function Button({ children, variant = "primary", className = "", ...props }) {
  const cls = variant === "primary" ? "btn-gold" : variant === "outline" ? "btn-outline" : "btn-outline !border-maroon !text-maroon hover:!bg-maroon hover:!text-ivory";
  return <button className={`${cls} ${className}`} {...props}>{children}</button>;
}

export function Toolbar({ children }) { return <div className="flex flex-wrap gap-2 items-center justify-between mb-4">{children}</div>; }

export function Table({ columns, rows, empty = "No data", actions, getKey = (r) => r.id, testIdPrefix = "row" }) {
  return (
    <div className="overflow-x-auto border border-navy-900/10 bg-white">
      <table className="w-full text-sm">
        <thead className="bg-navy-900 text-gold">
          <tr>
            {columns.map((c, i) => (
              <th key={i} className="text-left p-4 text-[10px] tracking-[0.2em] uppercase font-semibold">{c.title}</th>
            ))}
            {actions && <th className="text-right p-4 text-[10px] tracking-[0.2em] uppercase font-semibold">Actions</th>}
          </tr>
        </thead>
        <tbody>
          {rows.length === 0 && (
            <tr><td colSpan={columns.length + (actions ? 1 : 0)} className="p-8 text-center text-navy-900/50">{empty}</td></tr>
          )}
          {rows.map((r, i) => (
            <tr key={getKey(r)} className="border-t border-navy-900/10 hover:bg-ivory-200/50" data-testid={`${testIdPrefix}-${getKey(r)}`}>
              {columns.map((c, j) => <td key={j} className="p-4 align-top">{c.render ? c.render(r, i) : r[c.key]}</td>)}
              {actions && <td className="p-4 text-right whitespace-nowrap">{actions(r, i)}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function Modal({ open, onClose, title, children, maxWidth = "max-w-2xl" }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="modal">
      <div className="absolute inset-0 bg-navy-900/70 backdrop-blur-sm" onClick={onClose} />
      <div className={`relative bg-ivory w-full ${maxWidth} max-h-[90vh] overflow-y-auto border border-gold/30 shadow-gold-lg`}>
        <div className="sticky top-0 bg-navy-900 text-ivory px-6 py-4 flex items-center justify-between">
          <div className="serif text-xl">{title}</div>
          <button onClick={onClose} className="text-gold hover:text-ivory" data-testid="modal-close">✕</button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const colors = {
    new: "bg-gold/15 text-gold-600",
    contacted: "bg-blue-100 text-blue-800",
    follow_up: "bg-yellow-100 text-yellow-800",
    converted: "bg-green-100 text-green-800",
    lost: "bg-red-100 text-red-800",
    draft: "bg-gray-200 text-gray-700",
    sent: "bg-blue-100 text-blue-800",
    accepted: "bg-green-100 text-green-800",
    rejected: "bg-red-100 text-red-800",
    paid: "bg-green-100 text-green-800",
    unpaid: "bg-red-100 text-red-800",
    partial: "bg-yellow-100 text-yellow-800",
  };
  return (
    <span className={`text-[10px] tracking-[0.15em] uppercase px-2 py-1 font-semibold ${colors[status] || "bg-gray-200 text-gray-700"}`}>
      {status || "—"}
    </span>
  );
}
